import { RootPaths } from "@src/appV2/App/paths";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_LIST_PATH } from "../../ShiftDiscovery/paths";
import { IN_HOME_USER_EVENTS } from "../lib/events";
import { ScreeningSurveyInfoLayout } from "./components/ScreeningSurveyInfoLayout";

export function ScreeningSurveyWaitlist() {
  useLogEffect(IN_HOME_USER_EVENTS.SCREENING_SURVEY_WAITLIST_PAGE_VIEWED);
  const history = useHistory();

  return (
    <ScreeningSurveyInfoLayout
      title="Thanks for Applying"
      icon="hourglass-illustration"
      action={{
        label: "Back to Shifts",
        onClick: () => {
          history.replace(`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`);
        },
      }}
    >
      <Text
        variant="h4"
        sx={(theme) => ({ textAlign: "center", color: theme.palette.text.secondary })}
      >
        We'll be in touch when there are opportunities you are qualified for nearby!
      </Text>
    </ScreeningSurveyInfoLayout>
  );
}
